<template>
  <div class="flex flex-col items-center">
    <div class="p-2 sm:p-4 bg-surface-50 dark:bg-surface-400/5 rounded-lg w-full">
      <DragImageIllustration class="max-w-full" />
    </div>

    <div class="mt-6">
      <p class="font-semibold text-lg text-primary mb-4">
        {{ $t("dragImageTipTitle") }}
        <span>
          <SparklesIcon class="h-5 w-5 text-yellow-500 inline-block" />
        </span>
      </p>
      <p>
        {{ $t("dragImageTipText") }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import DragImageIllustration from "./DragImageIllustration.vue";
import { SparklesIcon } from "@heroicons/vue/24/solid";
</script>
